export default __webpack_public_path__ + "static/components-dont-4761462d22b01954a2ebc94f8ee19e46.png";